import { Loading } from 'apps/builder/components/shared/animations'

export const LoadingPDF = () => (
    <>
        <Loading />
        <h3 className="t-center">Creating your PDF...</h3>
    </>
)